<div class="lg-sidebar-switch__header">{{ title }}</div>
<div class="lg-sidebar-switch__models">
    <ul>
        @for (product of products$ | async; track product) {
            <li>
                <a
                    [href]="_currentProductId !== product.id ? product.url : '#'"
                    [class.lg-sidebar-switch__models--active]="_currentProductId === product.id"
                    [class.lg-sidebar-switch__models--disabled]="product.disabled"
                >
                    <div class="lg-sidebar-switch__models__logo">
                        @if (product.icon != null) {
                            <lg-icon [icon]="product.icon" size="medium"> </lg-icon>
                        } @else {
                            <div
                                [class]="
                                    'lg-sidebar-switch__models__logo--custom ' +
                                    (product.iconClass ?? '')
                                "
                            ></div>
                        }
                    </div>
                    <div class="lg-sidebar-switch__models__label">
                        <div class="lg-sidebar-switch__models__label__name">{{ product.name }}</div>
                        @if (product.shortDescription) {
                            <div class="lg-sidebar-switch__models__label__description">
                                {{ product.shortDescription }}
                            </div>
                        }
                    </div>
                </a>
            </li>
        }
    </ul>
</div>
